import React, { FC } from "react";
import styles from "./avelios-spinner.module.scss";

export const SpinningIcon: FC = () => {
  return (
    <div className={styles.ldsDefaultWrapper}>
      <div className={styles.ldsRipple}>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
